<template>
    <div>
        <div v-if="carregando" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else class="u-mt-20" style="padding: 20px 12px;">
            <h4><i class="el-icon-warning-outline"></i> Ocorrências</h4>
            <p style="color:#909399;">Aqui você acompanha as ocorrências registradas.</p>

            <el-table :data="ocorrencias" stripe style="width: 100%;" empty-text="Nenhuma ocorrência registrada.">
                <el-table-column label="Data" width="120">
                    <template slot-scope="scope">{{ formatarData(scope.row.data) }}</template>
                </el-table-column>
                <el-table-column label="Tipo" min-width="140">
                    <template slot-scope="scope">{{ scope.row.tipo_ocorrencia ? scope.row.tipo_ocorrencia.nome : '-' }}</template>
                </el-table-column>
                <el-table-column label="Turma" min-width="180">
                    <template slot-scope="scope">{{ scope.row.turma && scope.row.turma.curso ? (scope.row.turma.curso.nome + ' / ' + scope.row.turma.nome) : '-' }}</template>
                </el-table-column>
                <el-table-column label="Descrição" min-width="260">
                    <template slot-scope="scope">{{ scope.row.descricao || '-' }}</template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Ocorrencias',
    data: () => ({
        carregando: false,
        ocorrencias: []
    }),
    mounted () {
        this.carregar()
    },
    methods: {
        carregar () {
            this.carregando = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/portal/get-ocorrencias-for-portal-aluno`,
                {},
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.ocorrencias = Array.isArray(response.data) ? response.data : []
                this.carregando = false
            }).catch(error => {
                this.carregando = false
                this.$store.commit('throwException', error)
            })
        },
        formatarData (d) {
            return d ? this.$moment(d).format('DD/MM/YYYY') : '-'
        }
    }
}
</script>
